import React from 'react';

import { TabList, TabStore } from '@ariakit/react';

import { getCodeBlockId } from '../../../utils/codeBlock';

import { CodeBlockHeaderTab } from './CodeBlockHeaderTab/CodeBlockHeaderTab';
import * as classes from './style.module.scss';

interface Props {
  tab: TabStore;
  items: string[];
  'aria-label': string;
}

export const CodeBlockHeaderTabs: React.FC<Props> = ({
  tab,
  items,
  'aria-label': ariaLabel,
}) => {
  const activeId = tab.useState('activeId');

  return (
    <TabList store={tab} className={classes.root} aria-label={ariaLabel}>
      {items?.map((file, i) => {
        const id = getCodeBlockId(file, i);
        return (
          <CodeBlockHeaderTab
            key={id}
            id={id}
            activeId={activeId}
            index={i}
            file={file}
            interactive
          />
        );
      }) || null}
    </TabList>
  );
};
